module.exports = __webpack_public_path__ + "img/forte-21.8c62ef5f.png";